export const SUBSCRIPTION_STATES = {
	SUBSCRIBED: 'subscribed',
	UNSUBSCRIBED: 'unsubscribed',
	OPTED_IN: 'opted_in',
};

/**
 * Converts a boolean value to a subscription state string
 * @param {boolean} value - true for subscribed, false for unsubscribed
 * @returns {string} 'subscribed' or 'unsubscribed'
 */
export const booleanToState = (value) =>
	value ? SUBSCRIPTION_STATES.SUBSCRIBED : SUBSCRIPTION_STATES.UNSUBSCRIBED;

/**
 * Converts a subscription state string to a boolean
 * @param {string} state - 'subscribed', 'unsubscribed', or 'opted_in'
 * @returns {boolean} true if subscribed or opted_in, false otherwise
 */
export const stateToBoolean = (state) =>
	state === SUBSCRIPTION_STATES.SUBSCRIBED || state === SUBSCRIPTION_STATES.OPTED_IN;
